//#region src/services/metrics/metricAggregationTypes.ts
/**
* Metric Aggregation Types
*
* Shared types for the metric aggregation system. Used by both the backend
* (MetricAggregationService) and the frontend (chart components).
*/
/** Pipeline ID for per-user token usage aggregation. */
const USER_TOKENS_PIPELINE_ID = "users:tokens";
/** Pipeline ID for per-user COGS aggregation. */
const USER_COSTS_PIPELINE_ID = "users:costs";
/** Reserved series prefix for cross-model total series (e.g., "total:inputTokens"). */
const TOTAL_SERIES_PREFIX = "total:";
const RPC_EVENT_METRIC_REBUILD_PROGRESS_IDENT = "metricAggregation.rebuildProgress";
const METRIC_REBUILD_GROUP_TYPE = "admin";
const METRIC_REBUILD_GROUP_ID = "providerProfiles";
const RPC_EVENT_METRIC_REBUILD_PROGRESS = {
	ident: RPC_EVENT_METRIC_REBUILD_PROGRESS_IDENT,
	description: "Emitted during a pipeline rebuild to report progress",
	groups: [METRIC_REBUILD_GROUP_TYPE],
	params: [
		{
			name: "pipelineId",
			type: "string",
			description: "The pipeline being rebuilt"
		},
		{
			name: "percent",
			type: "number",
			description: "Completion percentage 0-100"
		},
		{
			name: "done",
			type: "boolean",
			description: "True when rebuild is complete"
		}
	]
};

//#endregion
export { METRIC_REBUILD_GROUP_ID, METRIC_REBUILD_GROUP_TYPE, RPC_EVENT_METRIC_REBUILD_PROGRESS, RPC_EVENT_METRIC_REBUILD_PROGRESS_IDENT, TOTAL_SERIES_PREFIX, USER_COSTS_PIPELINE_ID, USER_TOKENS_PIPELINE_ID };
//# sourceMappingURL=metricAggregationTypes.js.map